import React, { Component } from 'react';
import Step from './Step';
import RiskProfileChart from './RiskProfileChart';

export default class RiskProfileStep extends Component {
    render() {
        let name = this.props.responses ? this.props.responses['name'] : '';
        return (
            <Step className={this.props.className}>
                <h1>{name} Plan Profile</h1>
                <p>
                    <em>Target-Date Blueprint</em> has assessed the plan's demographics and preferences based on your responses to the preceding questions. <br/>
                    The graphic below depicts your plan's unique risk profile. The TDF rankings on the following screen reflect this profile.
                </p>
                <div style={{ width: '85%', margin: '30px auto' }}>
                    <RiskProfileChart />              
                </div>
            </Step>
        );
    }
}
